import * as React from "react"
const ModalCloseCircle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={"1em"}
    height={"1em"}
    fill="none"
    viewBox='0 0 45 45 '
    {...props}
  >
    <circle cx={22.5} cy={22.5} r={22.5} fill="#D9D9D9" />
    <path
      fill="#484848"
      d="m13.945 30 6.864-9.592-.022 3.63-6.644-9.438h5.83l3.872 5.72-2.486.022 3.784-5.742h5.588l-6.644 9.24v-3.608L31.061 30h-5.94l-3.872-5.984 2.398-.022L19.863 30h-5.918Z"
    />
  </svg>
)
export default ModalCloseCircle
